function displayLevelNumber(level) {
  return level.fields['#']
}

export default displayLevelNumber
